<div *ngIf="showNoResults" class="no-results-message">
  <mat-icon>search_off</mat-icon>
  <p>No results were found from your search</p>
</div>

<mat-card *ngIf="!showNoResults && teammateInformation && teammateInformation.displayName" class="results-card">
    <mat-card-header>
      <mat-card-title>Teammate Information</mat-card-title>
    </mat-card-header>
    <mat-card-content class="info-grid">
      <div class="info-item"><strong>Display Name:</strong> <span>{{teammateInformation.displayName}}</span></div>
      <div class="info-item"><strong>Email:</strong> <span>{{teammateInformation.email}}</span></div>
      <div class="info-item"><strong>Job Function:</strong> <span>{{teammateInformation.jobFunctionDesc}}</span></div>
      <div class="info-item"><strong>Employee Number:</strong> <span>{{teammateInformation.employeeNumber}}</span></div>
      <div class="info-item"><strong>Status:</strong> <span>{{teammateInformation.status}}</span></div>
      <div class="info-item"><strong>Username:</strong> <span>{{teammateInformation.userLogin}}</span></div>
    </mat-card-content>
</mat-card>